import React from 'react'
import styled from 'styled-components'

const StyledButton = styled.button`
  width: ${props => props.width};
  height: 40px;
  border: 1px solid ${props => props.backgroundColor};
  background-color: ${props => props.backgroundColor};
  margin-top: ${props => props.marginTop};
  padding: 10px;
  color: ${props => props.color};
  transition: 0.3s;
  font-family: 'Bellota Text', cursive;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: ${props => props.align};
  
  :hover {
    cursor: pointer;
    background-color: ${props => props.color};
    color: ${props => props.backgroundColor};
  }
`

const Button = (
    {
        name = "envoyer",
        value = "ENVOYER",
        width = "100%",
        onClick = null,
        align = "center",
        marginTop = "50px",
        inverted = false,
        children
    }) => {
    let backgroundColor = "#233647"
    let color = "#fff"
    if (inverted) {
        backgroundColor = "#fff"
        color = "#233647"
    }
    return (
        <StyledButton type="submit" name={name} width={width} onClick={onClick} align={align} marginTop={marginTop}
                      backgroundColor={backgroundColor} color={color}>
            {value}{children}
        </StyledButton>
    )
}

export default Button
